var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"products"}},[_c('b-container',{staticClass:"py-5"},[_c('h2',{staticClass:"lead"},[_vm._v(" Products page coming soon. Please contact me to discuss products. Thank you. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }